/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable import/no-unresolved */
import { Typography } from '@mui/material';
import { useFormikContext } from 'formik';
import { useSelector, useDispatch } from 'react-redux';

import { selectOrder } from '@/store/selectors';
import { useFetchPosProfileDetails } from '@/services/hooks';
import { updateChange } from '@/store/slices/order';

const Change = () => {
  const dispatch = useDispatch();
  const { paid_amount: paidAmount, total } = useSelector(selectOrder);
  const { data: profile } = useFetchPosProfileDetails();

  const { values } = useFormikContext<any>();

  const objectValues: number[] = Object.values(values);

  const totalAmount = objectValues.reduce(
    (curr: number, total: number): number => curr + total,
    0,
  );

  const amountToBePaid = total - paidAmount;

  let amountLeft = totalAmount - amountToBePaid;

  if (amountLeft <= 0) {
    amountLeft = 0;
  }

  dispatch(updateChange(amountLeft));

  return (
    <Typography
      sx={{
        fontWeight: '400',
        fontFamily: 'Montserrat',
        fontSize: '13px',

        '& span': {
          ml: 1,
          mt: 4,
        },
      }}
    >
      Change:
      <span>
        {profile?.currency}
        {amountLeft.toLocaleString('en-US')}
      </span>
    </Typography>
  );
};

export default Change;
